export interface VersionInfo {
  major: number;
  minor: number;
  patch: number;
  build: number;
  buildDate: string;
  commitHash?: string;
}

export const VERSION: VersionInfo = {
  major: 1,
  minor: 3,
  patch: 4,
  build: 5,
  buildDate: '2026-09-28T18:15:59.091Z',
  commitHash: 'c1709eb5891cea8ff574e14a74641b57c5bc4663'
};

export function getVersionString(version: VersionInfo = VERSION): string {
  return `${version.major}.${version.minor}.${version.patch}`;
}

export function getFullVersionString(version: VersionInfo = VERSION): string {
  const versionStr = getVersionString(version);
  const buildDate = new Date(version.buildDate).toLocaleDateString();
  let fullVersion = `v${versionStr} (${buildDate})`;

  if (version.commitHash) {
    fullVersion += ` - ${version.commitHash.substring(0, 8)}`;
  }

  return fullVersion;
}
